import { createContext, useReducer, useState } from "react";

export const GuiaBusquedaCont=createContext<any>(-1);

const reducer=(state:any,action:any):number=>
{
    return action.input;
}

export const GuiaBusquedaGeneral=({children}:any)=>
{
    const [GuiaBusqueda,dispatch]=useReducer(reducer,-1);
    const [GuiaBusquedaPreAlerta,SetGuiaBusquedaPreAlerta]=useState<any>("")

    const ActualizacionGuia=(number:number)=>
    {
        dispatch({input:number})
    }

    return (
        <GuiaBusquedaCont.Provider value={{GuiaBusqueda,ActualizacionGuia,GuiaBusquedaPreAlerta,SetGuiaBusquedaPreAlerta}}>
            {children}
        </GuiaBusquedaCont.Provider>
    )
}